import { Text } from '@northladder/i18n';

import { translations } from '../../../translations';

interface IButtonUploadImageProps {
  isEnabled?: boolean;
  onClick: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * Renders a button which on press starts the upload process of the currently
 * viewed images.
 */
export function ButtonUploadImage({
  onClick,
  isEnabled = true,
}: IButtonUploadImageProps) {
  return (
    <button
      className="form-btn w-auto"
      disabled={!isEnabled}
      onClick={onClick}
      type="button"
    >
      <Text text={translations.cropping.upload} />
    </button>
  );
}
